export const ROUTES = {
  DASHBOARD: {
    FILMINE: '/filgram/dashboard/filmine',
    MY_PROFILES: '/filgram/dashboard/my-profiles',
    MY_DEALS: '/filgram/dashboard/my-deals',
    CONNECTED_ADDRESSES: '/filgram/dashboard/connected-addresses',
    ACCOUNT_SETTINGS: '/filgram/dashboard/account-settings',
    STORAGE_REQUESTS: '/filgram/dashboard/storage-requests',
    MY_FILES: '/filgram/dashboard/my-files',
    CHAT: '/filgram/dashboard/messages',
    INDEX: '/filgram/dashboard',
    HOW_TO: {
      STORE: '/filgram/dashboard/how-to/store',
      RETRIEVE: '/filgram/dashboard/how-to/retrieve',
      LISTING: '/filgram/dashboard/how-to/listing',
      CONNECTING_YOUR_MINERS: '/filgram/dashboard/how-to/connecting-your-miners',
      MINERS_DASHBOARD: '/filgram/dashboard/how-to/miners-dashboard',
      API_REFERENCE: '/filgram/dashboard/how-to/api-reference',
    },
  },
  EXPLORE: '/filgram/explore',
  STORAGE_PROVIDER: '/filgram/storage-provider/',
  DATA_CENTER: '/filgram/data-center/',
  HOME: '/filgram',
  FAQ: '/filgram/faq',
  PRIVACY_POLICY: '/filgram/privacy-policy',
  TERMS_AND_CONDITIONS: '/filgram/terms-and-conditions',
  LOGIN: '/filgram/login',
};
